import { FormSection } from "@duosoftbg/nacid-components";
import React from "react";
import StudiedSubjectFormFields from "./common/StudiedSubjectFormFields";

const StudiedSubjectFormSection = () => {
  return (
    <FormSection label={"t.studied.subjects"}>
      <StudiedSubjectFormFields
        baseField={"studiedSubjects"}
        infoText={"m.diplomaGrade.data.info"}
        isSubjectsDataRequired={false}
      />
    </FormSection>
  );
};
export default StudiedSubjectFormSection;
